import DocumentTextArea from './_DocumentTextArea';

export default DocumentTextArea;
